import './scss/main.scss';
import Animasection from "./animasection";
import Observer from 'tailwindcss-intersect';

Observer.start();
jQuery(function ($) {
    $('#backnumbers h4').on('click', function (e) {
        $(e.currentTarget).next().toggleClass("open");
    });
    window.addEventListener('pageshow', (event) => {
        let body = $('body');
        if (event.persisted && body.hasClass('js-fadeout')) {
            body.removeClass('js-fadeout').addClass('js-fadein')
        }
    });
});
jQuery(function ($) {
    $('#cart #cart_table select.quantity').change(function () {
        let $elm = $(this);
        let quantity = $elm.val();
        let prevVal = $elm.data('prev');
        if (uscesCart.upCart()) {
            $elm.data('prev', quantity);
            let $form = $elm.parents('form');
            $('<input>').attr({
                'type': 'hidden',
                'name': 'upButton',
                'value': '数量更新'
            }).appendTo($form);
            $form.submit();
        } else {
            $elm.val(prevVal);
        }
    })
});

jQuery(function () {
    Animasection.observeAll();
});
